@if (isPermissionError) {
  <div class="col-sm-12">
    <br />
    <h5>
      <div class="text-danger small">{{"You do not have permission to access this page." | translate}}</div>
    </h5>
  </div>
}
<appspinner [startSpinner]="nodeService.showAppLoader"></appspinner>
@if (!nodeService.showAppLoader && !isPermissionError) {
  <div class="row">
    <h6 class=" mb-1">{{ 'Available libraries for process :' | translate }}
      <h6 class="badge cds-badge active text-bg-info">{{nodeService.currentProcessName}}</h6>
    </h6>
    <div class="card cds-card-shadow mb-4">
      <div class="card-body">
        <div class="col-sm-12">
          <div class="col-12 mb-2">
            <input class="form-control searchBox" placeholder="{{ 'Quick Filter' | translate}}" [(ngModel)]="searchText">
          </div>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-12"><br /></div>
          <div class="col-sm-12">
            <div class="scroll-only-x">
              <table aria-describedby="table-proc-libParent" class="table table-striped"
                [mfData]="liabraries | filter :'id,libraryType,description,connection,processAll,reporting': searchText"
                #mf="mfDataTable" mfSortBy="id" [mfRowsOnPage]="15">
                <thead>
                  <tr>
                    <th>
                      <mfDefaultSorter by="id">{{ 'Code' | translate }}</mfDefaultSorter>
                    </th>
                    <th>
                      <mfDefaultSorter by="libraryType">{{ 'Type' | translate }}</mfDefaultSorter>
                    </th>
                    <th>
                      <mfDefaultSorter by="description">{{ 'Notes' | translate }}</mfDefaultSorter>
                    </th>
                    <th>
                      <mfDefaultSorter by="connection">{{ 'Logical Operator' | translate }}</mfDefaultSorter>
                    </th>
                    <th>
                      <mfDefaultSorter by="processAll">{{ 'Process All' | translate }}</mfDefaultSorter>
                    </th>
                    <th>
                      <mfDefaultSorter by="reporting">{{ 'Append' | translate }}</mfDefaultSorter>
                    </th>
                  </tr>
                </thead>
                @if (liabraries.length > 0) {
                  <tbody>
                    @for (value of mf.data; track value) {
                      <tr class="cursor" (click)="showVariablesDetails(value)"
                        [ngStyle]="{'background-color': value.id === liabraryName ? 'antiquewhite' : ''}">
                        <td>{{value.id}}</td>
                        <td>{{value.libraryType}}</td>
                        <td>{{value.description}}</td>
                        <td>{{value.connection}}</td>
                        <td>{{value.processAll}}</td>
                        <td>{{value.calcMode && value.calcMode === 'APPEND' ? true : false}}</td>
                      </tr>
                    }
                  </tbody>
                }
                @if ((liabraries | filter :'id,libraryType,description,connection,processAll,reporting': searchText).length > 15) {
                  <tfoot
                    >
                    <tr>
                      <td colspan="10">
                        <mfBootstrapPaginator [rowsOnPageSet]="[15,50,100]"></mfBootstrapPaginator>
                      </td>
                    </tr>
                  </tfoot>
                }
              </table>
              @if (liabraries.length === 0) {
                <div class="col-sm-12 text-center">
                  <h5>
                   <div class="text-danger small">{{ 'No records found.' | translate }}</div>
                  </h5>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (rulesInfo.length > 0) {
      <h6 class=" mb-1">{{ 'Details of library :' | translate }}
        <h6 class="badge cds-badge active text-bg-primary">{{liabraryName}}</h6>
      </h6>
      <div class="card cds-card-shadow">
        <div class="card-body">
          <div class="col-12">
            <table aria-describedby="table-proc-libChild" class="table table-striped"
              [mfData]="ruleObj" #mf="mfDataTable" [mfRowsOnPage]="15">
              <thead>
                <tr>
                  <th>
                    <mfDefaultSorter by="id">{{ 'Code' | translate }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="getVariableName(condition)">{{ 'Variable' | translate }}
                    </mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="scoreValue">{{ 'Value' | translate }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="condition">{{ 'Condition' | translate }}</mfDefaultSorter>
                  </th>
                  @if (shared == 'true') {
                    <th class="actions-col">
                      Override
                    </th>
                  }
                  <th>
                    <mfDefaultSorter by="disabled">{{ 'Status' | translate }}</mfDefaultSorter>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (subValue of mf.data; let i = $index; track subValue) {
                  <tr>
                    <td>{{ subValue.id }}</td>
                    <td>{{ subValue.variable }}</td>
                    <td>{{ subValue.scoreValue }}</td>
                    <td>{{ subValue.condition | VariableNamefilter: categoryVariableMap }}</td>
                    @if (shared == 'true') {
                      <td class="text-center text-secondary">
                        @if (subValue.override.enabled) {
                          <i  class="fa fa-info-circle" aria-hidden="true"  data-toggle="tooltip" data-placement="top" title="Original value: {{!subValue.disabled}}"></i>
                        }
                      </td>
                    }
                    <td class="text-center">
                      <div class="form-check form-switch">
                        <input  class="form-check-input" type="checkbox" role="switch" [id]="`flexSwitchCheckDefault${i}`"
                          [checked]="subValue.override.enabled? !subValue.override.value : !subValue.disabled" [disabled]="isDisableToggleButton"
                          (change)="onChange(subValue, i)">
                        </div>
                    </td>
                  </tr>
                }
              </tbody>
              @if (ruleObj.length > 15) {
                <tfoot>
                  <tr>
                    <td colspan="10">
                      <mfBootstrapPaginator [rowsOnPageSet]="[15,50,100]"></mfBootstrapPaginator>
                    </td>
                  </tr>
                </tfoot>
              }
            </table>
          </div>
        </div>
      </div>
    }
  </div>
}